import React from "react";
import styles from "./RsvpQA.module.css";
import { Col, Layout, Row } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import Rsvp from "../../../../assets/rsvp5.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const RsvpQA = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };

  return (
    <div style={myStyle} className={styles.mainContainer}>
      <Layout className="site-layout">
        <Header
          mainHeader={styles.headerColor}
          isProfile={true}
          title={"RSVP"}
          style={{
            padding: 0,
            background: "var(--white-color)",
            height: 85,
          }}
          onBackClick={() => navigate(-1)}
        />
      </Layout>
      <Row className={styles.mainDiv}>
        <Col xs={24} md={11} xl={10} className={styles.innerDiv}>
          <div className={styles.innerDiv2}>
            <TextComponent textClass={styles.title} text="Q/A" />
            <TextComponent
              textClass={styles.text2}
              text="For all our friends and family who
              have lots of questions, please check
              out Q/A"
            ></TextComponent>

            {rsvpData?.question_and_answers?.map((item) => (
              <>
                <TextComponent
                  textClass={styles.text}
                  text={item?.question}
                ></TextComponent>
                <TextComponent
                  textClass={styles.text3}
                  text={item?.answer}
                ></TextComponent>
              </>
            ))}
            <BiSolidChevronRightCircle
              className={styles.con1}
              size={30}
              cursor={"pointer"}
              onClick={() => navigate("/rsvp/rsvpPeople", { state: state })}
            />
          </div>
        </Col>
        {/* <Col xs={24} md={12} xl={12} className={styles.imgContainer}>
          <img className={styles.innerImg} src={Rsvp} />
        </Col> */}
      </Row>
    </div>
  );
};

export default RsvpQA;
